import type { AssetsSegmentSchemaWithIdPatched } from '@iconik-io/iconik-api/src/schema_patched/assets_segments';

type GetAllowedDeletingCommentsArgs = {
  userId: string | undefined;
  shareUserEmail: string | undefined;
  shareSessionId?: string | undefined;
  comment: AssetsSegmentSchemaWithIdPatched;
  canDeleteComments: boolean;
  isCommentInScope: boolean;
  isInternalUser: boolean;
  canEditOtherUsersComments?: boolean;
};

export function getIsAllowedDeletingComments({
  shareUserEmail,
  shareSessionId,
  userId,
  comment,
  canDeleteComments,
  isCommentInScope,
  isInternalUser,
  canEditOtherUsersComments,
}: GetAllowedDeletingCommentsArgs) {
  // Internal users are not restricted to isCommentInScope — they can delete
  // across share contexts (e.g. when browsing an asset via a collection share
  // link). The isCommentInScope guard exists only to prevent share guests
  // from deleting comments that belong to a different share.
  if (
    canEditOtherUsersComments &&
    canDeleteComments &&
    (isInternalUser || isCommentInScope)
  ) {
    return true;
  }

  const isSameShareSession =
    Boolean(shareSessionId) && comment.share_session_id === shareSessionId;

  // Internal Iconik users must match by user_id only — not by email — to avoid
  // letting an authenticated user delete a guest comment posted with the same email.
  const isCommentAuthor =
    userId === comment.user_id ||
    (!isInternalUser &&
      (comment.share_user_email === shareUserEmail || isSameShareSession));

  return (
    isCommentAuthor && canDeleteComments && (isInternalUser || isCommentInScope)
  );
}
